import { render, staticRenderFns } from "./HomeClients.vue?vue&type=template&id=53fed60e&"
import script from "./HomeClients.vue?vue&type=script&lang=ts&"
export * from "./HomeClients.vue?vue&type=script&lang=ts&"
import style0 from "./HomeClients.vue?vue&type=style&index=0&id=53fed60e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseSectionTitle: require('/codebuild/output/src2039654861/src/threease_lp/components/shared/Base/BaseSectionTitle.vue').default})
